import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import ReversalTransactionInfo from './ReversalTransactionInfo';

type FC = FunctionComponent<vp.TransactionId>;

const ReversalTransactionContainer: FC = (props: vp.TransactionId) => {
  const { TransactionID } = props;

  return <div>{TransactionID && <ReversalTransactionInfo TransactionId={TransactionID} />}</div>;
};

export default ReversalTransactionContainer;
